/**
 * @fileoverview Send-message handlers for the Chat page.
 * @module pages/chat/useChatMessageHandlers
 */
import { useCallback } from "react";
import { sendChatMessages } from "./chatSendMessage.js";

/** Returns memoized message send handlers. */
const useChatMessageHandlers = (ctx) => {
  const handleSendMessage = useCallback(async () => {
    await sendChatMessages(ctx);
  }, [
    ctx.messageInput,
    ctx.selectedFile,
    ctx.selectedChat,
    ctx.ws,
    ctx.pendingFileUploads,
    ctx.setChatMessages,
    ctx.setChats,
    ctx.setMessageInput,
    ctx.setSelectedFile,
    ctx.setShowFileUpload,
    ctx.setFileError,
    ctx.setIsFileUploading,
  ]);

  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        handleSendMessage();
      }
    },
    [handleSendMessage],
  );

  return { handleSendMessage, handleKeyPress };
};

export default useChatMessageHandlers;
